import { render, staticRenderFns } from "./TransparencyTypesHeader.vue?vue&type=template&id=17af73cc&scoped=true&"
import script from "./TransparencyTypesHeader.vue?vue&type=script&lang=js&"
export * from "./TransparencyTypesHeader.vue?vue&type=script&lang=js&"
import style0 from "./TransparencyTypesHeader.vue?vue&type=style&index=0&id=17af73cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17af73cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardTitle,VIcon,VTextField})
